// eslint-disable  no-bitwise

/**
 * https://tools.ietf.org/html/rfc4122
 *
 * Adattato da: https://www.npmjs.com/package/uuid
 */
import { times, padStart } from 'lodash-es';

// Mappa da numero decimale a sua rappresentazione esadecimale.
const BYTE_TO_HEX = times(256, n => padStart(n.toString(16), 2, '0'));

// RegExp per testare se una stringa è un Guid.
export const GUID_REGEX = /[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}/;

export class Guid {
    static readonly EMPTY = '00000000-0000-0000-0000-000000000000';

    private static crypto: Crypto = window.crypto || window['msCrypto'];

    private readonly internalState: string;

    constructor() {
        let bytes = Array.prototype.slice.call(Guid.crypto.getRandomValues(new Uint8Array(16)));

        // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;

        bytes = bytes.map(byte => BYTE_TO_HEX[byte]);

        this.internalState = [
            bytes[0],
            bytes[1],
            bytes[2],
            bytes[3],
            '-',
            bytes[4],
            bytes[5],
            '-',
            bytes[6],
            bytes[7],
            '-',
            bytes[8],
            bytes[9],
            '-',
            bytes[10],
            bytes[11],
            bytes[12],
            bytes[13],
            bytes[14],
            bytes[15],
        ].join('');
    }

    public static isGuid(str: string): boolean {
        return GUID_REGEX.test(str);
    }

    public toString(): string {
        return this.internalState;
    }
}
